import React, { useState } from "react";
import './staff-modules.css';

const SAMPLE_REPORTS = [
  {
    id: 1,
    title: "Attendance Summary - August 2025",
    type: "Attendance",
    batch: "GNM 1st Year",
    generatedOn: "2025-09-01",
    downloadLink: "#"
  },
  {
    id: 2,
    title: "Internal Assessment Report - Term 1",
    type: "Assessment",
    batch: "GNM 2nd Year",
    generatedOn: "2025-08-20",
    downloadLink: "#"
  }
];

export default function Reports() {
  const [reports, setReports] = useState(SAMPLE_REPORTS);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    title: "",
    type: "",
    batch: ""
  });

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!form.title || !form.type || !form.batch) return;
    setReports([
      { 
        ...form, 
        id: Date.now(), 
        generatedOn: new Date().toISOString().slice(0,10),
        downloadLink: "#" 
      },
      ...reports
    ]);
    setForm({ title: "", type: "", batch: "" });
    setShowForm(false);
  };

  return (
    <div className="module-wrapper">
      <h2>Reports & Analytics</h2>
      <p>
        Generate, view, and download various academic and administrative reports. Choose report type and batch to generate a new report.
      </p>
      <div className="module-actions">
        <button className="primary-action" onClick={() => setShowForm((s) => !s)}>
          {showForm ? "Cancel" : "Generate Report"}
        </button>
      </div>
      {showForm && (
        <form className="report-form" onSubmit={handleFormSubmit}>
          <div className="form-row">
            <label htmlFor="title">Report Title:</label>
            <input name="title" id="title" value={form.title} onChange={handleInputChange} required />
          </div>
          <div className="form-row">
            <label htmlFor="type">Report Type:</label>
            <select name="type" id="type" value={form.type} onChange={handleInputChange} required>
              <option value="">--Select--</option>
              <option value="Attendance">Attendance</option>
              <option value="Assessment">Assessment</option>
              <option value="Clinical">Clinical Posting</option>
              <option value="Rotation">Rotation Plan</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div className="form-row">
            <label htmlFor="batch">Batch:</label>
            <input name="batch" id="batch" value={form.batch} onChange={handleInputChange} required />
          </div>
          <button type="submit" className="primary-action">Generate</button>
        </form>
      )}
      <div className="reports-list">
        {reports.length === 0 && (
          <div className="empty-message">No reports generated yet.</div>
        )}
        {reports.map((report) => (
          <div className="report-card" key={report.id}>
            <div className="report-header">
              <span className="report-title">{report.title}</span>
              <span className="report-type">{report.type}</span>
            </div>
            <div className="report-meta">
              <span>Batch: {report.batch}</span>
              <span>Generated on: {report.generatedOn}</span>
            </div>
            <div className="report-actions">
              <a href={report.downloadLink} className="primary-action" download>
                Download
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}